import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { PB30T, PB97T } from '@h2/components/colors'
import { Text } from '@h2/components/typography/text'

const StyledLink = styled(Link)`
  &:link,
  &:active,
  &:visited {
    width: 100%;
    padding: 8px;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    white-space: nowrap;
    * {
      cursor: pointer;
    }
  }

  &:hover {
    background-color: ${PB97T};
  }
`
const renderIcon = ({ icon: Icon }) => (Icon ? <Icon size="tiny" /> : null)
const DropdownItem = ({ children, icon = null, href = '' }) => (
  <li>
    <StyledLink to={href}>
      {renderIcon({ icon })}
      <Text size="small" color={PB30T} weight="bold" margin="0 0 0 10px">
        {children}
      </Text>
    </StyledLink>
  </li>
)

DropdownItem.displayName = 'DropdownItem'
DropdownItem.propTypes = {
  children: PropTypes.string,
  icon: PropTypes.elementType,
  href: PropTypes.string
}

export { DropdownItem }
